module.exports = __webpack_public_path__ + "static/media/about1.1462a6d8.JPG";